<template>
  <div class="bonus-banner u-flex u-flex-items-center">
    <div class="bonus-banner__image u-flex-shrink-0">
      <img class="u-img-full" src="/static/i/bonus-coin.png" alt="" loading="lazy" />
    </div>
    <div class="bonus-banner__content u-flex-grow">
      <div class="bonus-banner__title" v-html="$t('lkBonuses.banner.title')"></div>
      <div class="bonus-banner__text">
        {{ $t('lkBonuses.banner.balance') }}: <span class="bonus-banner__value">{{ balanceFormatted }} {{ $tc('lkBonuses.bonuses', balance) }}</span>
      </div>
      <YtButton class="bonus-banner__button" tag="a" :href="link" color="violet" squared>
        {{ $t('lkBonuses.banner.more') }}
      </YtButton>
    </div>
    <a class="bonus-banner__arrow u-flex-shrink-0 u-stroke-deep-current u-text-secondary" :href="link">
      <SvgInline tag="span">
        <IconAngleUp />
      </SvgInline>
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";
import thousandsSeparator from "@/assets/js/utils/thousandsSeparator";
import SvgInline from '@/components/ui-kit/svg-inline/index.vue';
import YtButton from "@/components/ui-kit/yt-button/index.vue";
import IconAngleUp from '@/components/icons/list/icon-angle-up.vue';

export default {
  components: {
    SvgInline,
    YtButton,
    IconAngleUp,
  },
  data() {
    return {
      link: '/lk/bonuses/',
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    balance() {
      return this.user.bonuses.sum;
    },
    balanceFormatted() {
      return thousandsSeparator(this.balance);
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/global.scss";
@use "@/assets/scss/font-sf-pro.scss";

$b: '.bonus-banner';

#{$b} {
  position: relative;
  background: var.$gray-pale;
  border-radius: var.$rounded-12;
  padding: 24px;
  margin: 16px 0;

  * {
    font-family: var.$font-family-sf-pro-text;
  }

  > * + * {
    @include mixin.size-sm {
      margin-left: 24px;
    }
  }

  &__image {
    width: 76px;

    @include mixin.size-md-min {
      display: none;
    }

    img {
      vertical-align: top;
    }
  }

  &__content {
    font-weight: 600;

    > * + * {
      margin-top: 16px;
    }
  }

  &__title {
    font-size: 16px;
    letter-spacing: -0.02em;
    color: var.$text-dark;
  }

  &__text {
    font-size: 14px;
    letter-spacing: -0.02em;
  }

  &__value {
    color: var.$violet-3;
  }

  &__button {
    width: 100%;

    @include mixin.size-sm {
      display: none !important;
    }
  }

  &__arrow {
    width: 20px;

    @include mixin.size-md-min {
      display: none;
    }

    &::after {
      @include mixin.fill-abs();
      content: '';
      display: block;
      border-radius: inherit;
    }

    svg {
      transform: rotate(90deg);
    }
  }
}
</style>
